export const name = 'builderModuleLoader' as const

export const ReactTemplateSymbol = Symbol('ReactTemplateSymbol')
export const ESMLoaderSymbol = Symbol('ESMLoaderSymbol')
export const PromiseCacheSymbol = Symbol('PromiseCacheSymbol')
export const ImportMapSymbol = Symbol('ImportMapSymbol')
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
